/**
 * Recuperare automată la eșecul de încărcare a unui chunk lazy.
 *
 * După un deploy, o filă lăsată deschisă (mai ales pe iOS, unde fila stă
 * deschisă zile întregi) încearcă să încarce un chunk JS cu un hash vechi care
 * nu mai există pe server → 404 → `import()` respins → ecran alb sau card de
 * eroare din care utilizatorul nu poate ieși fără reload manual.
 *
 * Aici prindem exact acest tip de eroare și reîncărcăm pagina O SINGURĂ DATĂ
 * (cu un guard în sessionStorage), astfel încât reload-ul aduce build-ul nou.
 * Guard-ul previne bucla de reload dacă eroarea persistă din alt motiv.
 */
const RELOAD_GUARD_KEY = "ia:chunk-reload-at";
const RELOAD_COOLDOWN_MS = 30 * 1000;

function isChunkLoadMessage(message) {
   const text = String(message || "").toLowerCase();
   if (!text) return false;
   return (
      text.includes("chunkloaderror") ||
      text.includes("loading chunk") ||
      text.includes("loading css chunk") ||
      // Safari / iOS formulează altfel eșecul de import dinamic:
      text.includes("failed to fetch dynamically imported module") ||
      text.includes("importing a module script failed") ||
      text.includes("error loading dynamically imported module") ||
      text.includes("unable to preload css")
   );
}

function isChunkLoadError(error) {
   if (!error) return false;
   if (error.name === "ChunkLoadError") return true;
   return isChunkLoadMessage(error.message || error);
}

function recoverOnce() {
   let last = 0;
   try {
      last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
   } catch {
      last = 0;
   }

   const now = Date.now();
   // Am reîncărcat deja recent pentru asta: nu intra în buclă.
   if (last && now - last < RELOAD_COOLDOWN_MS) return;

   try {
      sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
   } catch {
      /* sessionStorage indisponibil (mod privat vechi iOS): continuăm oricum */
   }

   window.location.reload();
}

export function bootstrapChunkErrorRecovery() {
   if (typeof window === "undefined") return;

   window.addEventListener("error", (event) => {
      if (isChunkLoadError(event?.error) || isChunkLoadMessage(event?.message)) {
         recoverOnce();
      }
   });

   window.addEventListener("unhandledrejection", (event) => {
      if (isChunkLoadError(event?.reason)) {
         recoverOnce();
      }
   });
}
